import React from 'react';

import useUser from '../../../../hooks/useUser';

import { Robot2LineIcon } from '../../../../design-system/Icons';

const StageInstructions = ({ instructions }) => {
    const { user } = useUser();
    const { first_name } = user || {};

    const greeting = first_name ? `Hi ${first_name}!` : `Hi there!`;

    return (
        <div className="flex flex-col gap-2">
            <div className="flex items-center gap-3">
                <Robot2LineIcon width={26} height={26} color="#754DCF" />
                <p className="font-heading-bold text-heading-bold-s text-neutral-500">{greeting}</p>
            </div>

            {instructions && (
                <p className="font-heading-bold text-heading-bold-s text-neutral-500 whitespace-pre-wrap">
                    {instructions}
                </p>
            )}
        </div>
    );
};

export default StageInstructions;
